var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-monitor',{attrs:{"data":_vm.data,"constants":_vm.monitorConstants,"resId":_vm.serverId,"idKey":"id"}})
}
var staticRenderFns = []

export { render, staticRenderFns }